import React from 'react';
import { faBuilding } from '@fortawesome/pro-regular-svg-icons';

import PageHeader from 'components/ui/page_header';
import MergeButton from './merge_button';

export default function DuplicatesPageHeader() {
  return (
    <PageHeader>
      <PageHeader.Heading
        description="Manage your company database"
        icon={faBuilding}
        title="Companies"
      />
      <PageHeader.Actions>
        <div className="d-none d-md-flex">
          <MergeButton />
        </div>
      </PageHeader.Actions>
    </PageHeader>
  );
}
